var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ResponsiveImage',{staticClass:"responsive-image--ratio",class:("responsive-image--ratio-" + _vm.ratio),attrs:{"image":_vm.image,"imageClass":_vm.imageClass,"sizes":_vm.sizes,"hover":_vm.hover,"fitMode":_vm.fitMode,"quality":_vm.quality}})}
var staticRenderFns = []

export { render, staticRenderFns }